<div class="settings-p-msg"><p-messages [(value)]="systemMsg" [enableService]="false"></p-messages></div>
<div class="custom-modal modal-container" tabindex="0" id="wrapper">    
    <div class="modal-header view-modal-header">
        <div class="view-modal-title">
            <!--<img src="assets/images/training-popup-header-icon.png" >-->
            <span class="view-modal-title-text text-center">{{title}} ID#{{roID}}</span>
            <span *ngIf="roStatusData?.length > 0" class="rdstatus-text-col" [ngClass]="{'ro-status-col': !diagnationDomain}" [style.background-color]="roStatusData[0]['bgColor']">
                <div class="rdstatus-text-col-text">{{roStatusData[0]['statusName']}}</div>
            </span>
        </div>
        <div class="view-modal-actions">
            <ng-container *ngIf="isEditDeleteButtonVisible">
                <div *ngIf="noSupportFlag" class="read-ann-div" (click)="changeRepairOrderStatus(16)"><span class="read-ann-text"> Support Not Available&nbsp;&nbsp;<span style="position: relative;top: 1px;" class="p-button-icon p-button-icon-right pi pi-ban" aria-hidden="true"></span></span></div>
                <div *ngIf="enableSupportFlag" class="read-ann-div"><span class="read-ann-text"> Enable Support &nbsp;&nbsp;<span style="position: relative;top: 1px;" class="p-button-icon p-button-icon-right pi pi-check" aria-hidden="true"></span></span></div>
                <div *ngIf="calproFlag && removeReportFlag" class="read-ann-div est-action-btn remove-btn cursor" (click)="removeReport()"><span class=" p-button-icon p-button-icon p-button-icon-right pi pi-times" aria-hidden="true"></span><span class="est-text" aria-hidden="true">Remove ADAS Report</span></div>
                <div *ngIf="!endUser && generateInvoiceFlag" class="read-ann-div est-action-btn cursor inv-preview" (click)="generateinvoice()"><span class="est-text" [ngClass]="{'setOpacity5': detailCallbackData?.estimateListRef?.generateInvoiceSubmitFlag}">Generate Invoice</span></div>
                <div *ngIf="roEstimatePreview || roInvoicePreview" class="read-ann-div est-action-btn cursor print" (click)="print()"><span class="est-text">Print</span></div>
            </ng-container>
            <div *ngIf="!loading" class="view-more-actions">
                <ul>
                    <ng-container *ngIf="isEditDeleteButtonVisible && roFlag">
                        <li class="thread-owner-reply edit cursor" *ngIf="repairOrderEditFlag && isCustomerActive"
                            (click)="threadHeaderAction('edit')">
                            <div class="label-tt-cont moreDiv">
                                <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/edit.png"></span>
                                <span class="label-tt-cont-rt moreDivRt">
                                    <p class="more-cont">Edit</p>
                                </span>
                            </div>
                        </li>
                        <li class="thread-owner-reply delete cursor" *ngIf="repairOrderDeleteFlag && roFlag" (click)="threadHeaderAction('delete')">
                            <div class="label-tt-cont moreDiv">
                                <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/im-delete.png"></span>
                                <span class="label-tt-cont-rt moreDivRt">
                                    <p class="more-cont">Delete</p>
                                </span>
                            </div>
                        </li>
                    </ng-container>
                    <li *ngIf="roFlag" class="thread-owner-reply copy cursor" (click)="threadHeaderAction('copylink')">
                        <div class="label-tt-cont moreDiv">
                            <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/detail-view-copy-icon.png"></span>
                            <span class="label-tt-cont-rt moreDivRt">
                                <p class="more-cont">Copy Link</p>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
            <!--<div *ngIf="repairOrderApproveFlag" class="read-ann-div" (click)="threadHeaderAction('approve')"><span class="read-ann-text"> Approve&nbsp;&nbsp;<span style="position: relative;top: 1px;" class="p-button-icon p-button-icon-right pi pi-check" aria-hidden="true"></span></span></div>-->
            <!--div class="view-more-actions cursor" title="More" tooltipClass="post-submit-tooltip more-tooltip more-tooltip-new" triggers="click" [autoClose]="true"
                placement="bottom-right" [ngbTooltip]="more">
                <img src='assets/images/detail-view-more-icon.png' alt=''/><span></span>
            </div>
                <ng-template #more>
                <div class="thread-owner-reply cursor" *ngIf="repairOrderEditFlag" (click)="threadHeaderAction('edit')">                  
                    <div class="label-tt-cont moreDiv">
                    <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/edit.png"></span>
                    <span class="label-tt-cont-rt moreDivRt">
                        <p class="more-cont">Edit</p>
                    </span>
                    </div>
                </div>
                <div class="thread-owner-reply cursor" *ngIf="repairOrderDeleteFlag" (click)="threadHeaderAction('delete')">                  
                    <div class="label-tt-cont moreDiv">
                    <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/im-delete.png"></span>
                    <span class="label-tt-cont-rt moreDivRt">
                        <p class="more-cont">Delete</p>
                    </span>
                    </div>
                </div>
                <div class="thread-owner-reply cursor" (click)="threadHeaderAction('copylink')">                  
                    <div class="label-tt-cont moreDiv">
                    <span class="label-tt-cont-lt moreDivLt"><img src="assets/images/detail-view-copy-icon.png" ></span>
                    <span class="label-tt-cont-rt moreDivRt">
                        <p class="more-cont">Copy Link</p>
                    </span>
                    </div>
                </div> 
                </ng-template-->
            <span class="cursor close-btn" (click)="closeModal()">
                <img src="assets/images/list-close.png" alt="Close" />
            </span>
        </div>
    </div>
    <div class="modal-body view-modal-body">
        <div [style.height.px]="innerHeight">           
            <div class="thread-post-hover" [ngClass]="{'height-auto': previewPopupFlag}" [style.height.px]="innerHeight">
                <div #top id="top" class="ps thread-post" [perfectScrollbar]="sconfig" [ngClass]="{'htp-100': roTimeMotionFlag || roLogFlag}">
                    <div class="thread-detail-section" style="padding: 0 !important;" [ngClass]="{'htp-100': roTimeMotionFlag || roLogFlag}">
                        <div class="repair-order-detail-info" [ngClass]="{'bg-gray htp-100': roTimeMotionFlag || roLogFlag}">
                            <app-repair-order-detail-view (roDetailViewRef)="roDetailViewRef = $event" [roID]="roID" [fromDispatch]="fromDispatch" [popupHeight]="innerHeight" [newPage]="newPage" (closeEventEmit)="popupClose($event)" (detailCallback)="detailCallback($event)"></app-repair-order-detail-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</div>
<p-dialog [(visible)]="copiedModal" [modal]="true" [draggable]="false" [resizable]="true" class="copied-modal">
    <div class="text-center copied-txt">Link Copied</div>
  </p-dialog>
